// @needs-native-review — best-effort translation
import type { Translations } from '../types';

export const sw: Translations = {
  'meta.gameTitle': 'Luminary',

  'howto.title': 'Jinsi ya Kucheza',
  'howto.pieces.heading': 'Vipande',
  'howto.pieces.source': 'Chanzo',
  'howto.pieces.mirror': 'Kioo',
  'howto.pieces.switch': 'Swichi',
  'howto.pieces.exit': 'Mlango wa kutoka',
  'howto.pieces.wall': 'Ukuta',
  'howto.controls.heading': 'Vidhibiti',
  'howto.controls.clickSlot.line1': 'Bofya nafasi',
  'howto.controls.clickSlot.line2': 'weka kioo',
  'howto.controls.dragMirror.line1': 'Buruta kioo',
  'howto.controls.dragMirror.line2': 'zungusha',
  'howto.controls.rightClick.line1': 'Bofya kulia',
  'howto.controls.rightClick.line2': 'ondoa kioo',
  'howto.controls.hint':
    'Gurudumu la kipanya: zungusha kwa unyofu wa 1°.   Gusa kioo: zungusha kwa 15°.',
  'howto.objective.line1': 'Washa kila swichi — kufuli ya mlango wa kutoka hujifungua yenyewe.',
  'howto.objective.line2': 'Kisha bofya mlango wa kutoka. Tatua kwa vioo vichache iwezekanavyo.',

  'howtoColor.title': 'Rangi na Prisma',
  'howtoColor.pieces.heading': 'Vipande vipya',
  'howtoColor.pieces.prism': 'Prisma',
  'howtoColor.pieces.redSwitch': 'Swichi nyekundu',
  'howtoColor.pieces.yellowSwitch': 'Swichi ya manjano',
  'howtoColor.pieces.whiteSwitch': 'Swichi nyeupe',
  'howtoColor.how.heading': 'Jinsi zinavyofanya kazi',
  'howtoColor.how.line1': 'Boriti nyeupe hubeba mwanga mwekundu, kijani na buluu kwa wakati mmoja.',
  'howtoColor.how.line2':
    'Prisma hugawanya mwanga mweupe katika boriti tatu za rangi kwenye pande zake tatu.',
  'howtoColor.how.line3': 'Bofya prisma iliyowekwa ili kuzungusha uso wake wa kuingiza.',
  'howtoColor.switches.line1': 'Swichi huonyesha nukta za rangi — hiyo ndiyo rangi inayohitajika.',
  'howtoColor.switches.line2':
    'Swichi ya manjano (nukta nyekundu + kijani) inahitaji rangi zote mbili pamoja.',
  'howtoColor.switches.line3':
    'Swichi nyeupe (rangi zote tatu) inahitaji nyekundu, kijani NA buluu kwa wakati mmoja.',

  'options.hints.label': 'Onyesha pembe za vidokezo katika mafumbo',
  'options.hints.help':
    'Huonyesha pembe kati ya boriti inayoingia na ile inayoakisi katika kila mruko.',

  'level.01-intro.title': 'Habari Mwanga',
  'level.02-two-mirrors.title': 'Mizunguko Miwili',
  'level.03-corner.title': 'Ukuta Njiani',
  'level.04-two-targets.title': 'Shabaha Mbili',
  'level.05-tight.title': 'Finyu',
  'level.06-hello-color.title': 'Habari Rangi',
  'level.07-pick-a-side.title': 'Chagua Upande',
  'level.08-yellow.title': 'Manjano',
  'level.09-magenta.title': 'Magenta',
  'level.10-spectrum.title': 'Wigo',

  // PuzzleScene
  'puzzle.itemCounter': '{used}/{optimal}',
  'puzzle.hint.angleType.right': 'sahihi',
  'puzzle.hint.angleType.acute': 'kali',
  'puzzle.hint.angleType.obtuse': 'butu',
  'puzzle.hint.label': '{angle}°\n{type}',
};
